var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#paint0_linear_303_7443)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 12.772C6.375 6.67896 11.6572 1.875 18 1.875C24.3428 1.875 29.625 6.67896 29.625 12.772C29.625 18.4887 26.0807 25.2001 20.3622 27.6438C18.8609 28.2854 17.1391 28.2854 15.6378 27.6438C9.91933 25.2001 6.375 18.4887 6.375 12.772ZM18 4.125C12.7448 4.125 8.625 8.07114 8.625 12.772C8.625 17.7645 11.7831 23.5497 16.522 25.5748C17.4585 25.9751 18.5415 25.9751 19.478 25.5748C24.2169 23.5497 27.375 17.7645 27.375 12.772C27.375 8.07114 23.2552 4.125 18 4.125ZM18 11.625C16.9645 11.625 16.125 12.4645 16.125 13.5C16.125 14.5355 16.9645 15.375 18 15.375C19.0355 15.375 19.875 14.5355 19.875 13.5C19.875 12.4645 19.0355 11.625 18 11.625ZM13.875 13.5C13.875 11.2218 15.7218 9.375 18 9.375C20.2782 9.375 22.125 11.2218 22.125 13.5C22.125 15.7782 20.2782 17.625 18 17.625C15.7218 17.625 13.875 15.7782 13.875 13.5ZM5.39312 22.4949C5.81016 22.9554 5.77488 23.6669 5.31432 24.0839C4.46278 24.855 4.125 25.5931 4.125 26.25C4.125 27.3955 5.21101 28.8072 7.85506 29.9971C10.3935 31.1394 13.9793 31.875 18 31.875C22.0207 31.875 25.6065 31.1394 28.1449 29.9971C30.789 28.8072 31.875 27.3955 31.875 26.25C31.875 25.5931 31.5372 24.855 30.6857 24.0839C30.2251 23.6669 30.1898 22.9554 30.6069 22.4949C31.0239 22.0343 31.7354 21.999 32.1959 22.4161C33.3404 23.4524 34.125 24.7516 34.125 26.25C34.125 28.8324 31.8531 30.7957 29.0683 32.0489C26.1778 33.3496 22.2635 34.125 18 34.125C13.7365 34.125 9.82223 33.3496 6.93174 32.0489C4.14685 30.7957 1.875 28.8324 1.875 26.25C1.875 24.7516 2.65957 23.4524 3.80408 22.4161C4.26464 21.999 4.97608 22.0343 5.39312 22.4949Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_7443",
    x1: 2.4,
    y1: 37.5,
    x2: 36,
    y2: -0.00000124276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#762323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/MapPoint.02f86c9c83cb7c92f7fc1f9adc9fc7dc.svg";
export { ForwardRef as ReactComponent };